import { render } from "./OtpVerifyModal.vue?vue&type=template&id=970f27d0"
import script from "./OtpVerifyModal.vue?vue&type=script&lang=js"
export * from "./OtpVerifyModal.vue?vue&type=script&lang=js"

import "./OtpVerifyModal.vue?vue&type=style&index=0&id=970f27d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/OtpVerifyModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "970f27d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('970f27d0', __exports__)) {
    api.reload('970f27d0', __exports__)
  }
  
  module.hot.accept("./OtpVerifyModal.vue?vue&type=template&id=970f27d0", () => {
    api.rerender('970f27d0', render)
  })

}


export default __exports__